import {cva} from 'class-variance-authority'

export const buttonVariants = cva(
  [
    'inline-flex',
    'items-center',
    'justify-center',
    'whitespace-nowrap',
    'rounded-lg',
    'text-sm',
    'font-medium',
    'transition-all',
    'duration-150',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-2',
    'focus:ring-offset-white',
    'dark:focus:ring-offset-gray-900',
    'disabled:pointer-events-none',
    'disabled:opacity-50',
    'active:scale-95',
  ],
  {
    variants: {
      variant: {
        default: [
          'bg-violet-600',
          'text-white',
          'hover:bg-violet-700',
          'focus:ring-violet-500',
          'shadow-sm',
          'dark:bg-violet-600',
          'dark:hover:bg-violet-700',
        ],
        destructive: [
          'bg-red-600',
          'text-white',
          'hover:bg-red-700',
          'focus:ring-red-500',
          'shadow-sm',
          'dark:bg-red-600',
          'dark:hover:bg-red-700',
        ],
        outline: [
          'border',
          'border-violet-300',
          'bg-transparent',
          'text-violet-700',
          'hover:bg-violet-50',
          'hover:text-violet-800',
          'focus:ring-violet-500',
          'dark:border-violet-700',
          'dark:text-violet-300',
          'dark:hover:bg-violet-950/20',
          'dark:hover:text-violet-200',
        ],
        secondary: [
          'bg-white/80',
          'backdrop-blur-md',
          'border',
          'border-white/20',
          'text-gray-900',
          'hover:bg-white/90',
          'focus:ring-violet-500',
          'shadow-sm',
          'dark:bg-gray-900/80',
          'dark:border-gray-700/20',
          'dark:text-gray-100',
          'dark:hover:bg-gray-900/90',
        ],
        ghost: [
          'bg-transparent',
          'text-violet-700',
          'hover:bg-violet-100',
          'hover:text-violet-800',
          'focus:ring-violet-500',
          'dark:text-violet-300',
          'dark:hover:bg-violet-950/20',
          'dark:hover:text-violet-200',
        ],
        link: [
          'bg-transparent',
          'text-violet-600',
          'underline-offset-4',
          'hover:underline',
          'focus:ring-violet-500',
          'dark:text-violet-400',
        ],
        web3Connected: [
          'bg-green-600',
          'text-white',
          'hover:bg-green-700',
          'focus:ring-green-500',
          'shadow-sm',
          'dark:bg-green-600',
          'dark:hover:bg-green-700',
        ],
        web3Connecting: [
          'bg-yellow-500',
          'text-white',
          'hover:bg-yellow-600',
          'focus:ring-yellow-400',
          'shadow-sm',
          'dark:bg-yellow-500',
          'dark:hover:bg-yellow-600',
        ],
        web3Error: [
          'bg-red-600',
          'text-white',
          'hover:bg-red-700',
          'focus:ring-red-500',
          'shadow-sm',
          'border-2',
          'border-red-400',
          'dark:bg-red-600',
          'dark:hover:bg-red-700',
          'dark:border-red-500',
        ],
        web3Network: [
          'bg-blue-600',
          'text-white',
          'hover:bg-blue-700',
          'focus:ring-blue-500',
          'shadow-sm',
          'dark:bg-blue-600',
          'dark:hover:bg-blue-700',
        ],
        web3Pending: [
          'bg-orange-500',
          'text-white',
          'hover:bg-orange-600',
          'focus:ring-orange-400',
          'shadow-sm',
          'animate-pulse',
          'dark:bg-orange-500',
          'dark:hover:bg-orange-600',
        ],
      },
      size: {
        default: ['h-10', 'px-4', 'py-2'],
        sm: ['h-9', 'rounded-md', 'px-3', 'text-xs'],
        lg: ['h-11', 'rounded-lg', 'px-8'],
        xl: ['h-12', 'rounded-lg', 'px-10', 'text-base'],
        icon: ['h-10', 'w-10', 'rounded-lg'],
        iconSm: ['h-8', 'w-8', 'rounded-md'],
        iconLg: ['h-12', 'w-12', 'rounded-lg'],
      },
      fullWidth: {
        true: 'w-full',
        false: 'w-auto',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      fullWidth: false,
    },
  },
)
